import { request } from '../request';

const userApi = {
  /**
   * 登录
   */
  login(params: LoginParams) {
    return request<LoginParamsResponse>({
      path: '/pad/login/get/token',
      query: params,
      config: {
        isGatewayApi: true,
        ignoreErrorMessage: true,
      },
    });
  },
};

export default userApi;
